import { render, staticRenderFns } from "./shoppingMall.vue?vue&type=template&id=a7e1ce84&scoped=true&"
import script from "./shoppingMall.vue?vue&type=script&lang=js&"
export * from "./shoppingMall.vue?vue&type=script&lang=js&"
import style0 from "./shoppingMall.vue?vue&type=style&index=0&id=a7e1ce84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7e1ce84",
  null
  
)

export default component.exports